export default __webpack_public_path__ + "static/media/DNo.22-3.6165afde.jpg";